'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Copyright (c) 2015-present, Zippy Technologies
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CheckBox = require('../../CheckBox');

var _CheckBox2 = _interopRequireDefault(_CheckBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultCheckedIcon = function defaultCheckedIcon(_ref) {
  var style = _ref.style,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size;

  return _react2.default.createElement(
    'svg',
    { style: style, width: size, height: size, viewBox: '0 0 50 50' },
    _react2.default.createElement(
      'g',
      { id: 'icons', stroke: 'none', strokeWidth: '1' },
      _react2.default.createElement(
        'g',
        { id: 'Artboard', transform: 'translate(-90.000000, -159.000000)' },
        _react2.default.createElement(
          'g',
          {
            id: 'radio-button-icon',
            transform: 'translate(90.000000, 159.000000)'
          },
          _react2.default.createElement('path', {
            d: 'M25,50 C11.1928813,50 0,38.8071187 0,25 C0,11.1928813 11.1928813,0 25,0 C38.8071187,0 50,11.1928813 50,25 C50,38.8071187 38.8071187,50 25,50 Z M25,45 C36.045695,45 45,36.045695 45,25 C45,13.954305 36.045695,5 25,5 C13.954305,5 5,13.954305 5,25 C5,36.045695 13.954305,45 25,45 Z',
            id: 'Combined-Shape'
          }),
          _react2.default.createElement('circle', { id: 'Oval-2', cx: '25', cy: '25', r: '10' })
        )
      )
    )
  );
};

var defaultUncheckedIcon = function defaultUncheckedIcon(_ref2) {
  var style = _ref2.style,
      _ref2$size = _ref2.size,
      size = _ref2$size === undefined ? 24 : _ref2$size;

  return _react2.default.createElement(
    'svg',
    { viewBox: '0 0 24 24', height: size, width: size, style: style },
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  );
};

var ZippyRadioButton = function ZippyRadioButton(props) {
  var checkedIcon = defaultCheckedIcon || props.checkedIcon;
  var uncheckedIcon = defaultUncheckedIcon || props.uncheckedIcon;

  function renderNativeBrowserInput(config) {
    if (props.renderNativeBrowserInput) {
      return renderNativeBrowserInput(config);
    }
    config.inputProps.type = 'radio';
  }

  return _react2.default.createElement(_CheckBox2.default, _extends({}, props, {
    supportIndeterminate: false,
    checkedIcon: checkedIcon,
    uncheckedIcon: uncheckedIcon,
    renderNativeBrowserInput: renderNativeBrowserInput
  }));
};
function emptyFn() {}

ZippyRadioButton.defaultProps = {
  theme: 'default',
  rootClassName: 'zippy-react-toolkit-radio-button'
};

ZippyRadioButton.propTypes = {
  theme: _propTypes2.default.string,
  rootClassName: _propTypes2.default.string
};

exports.default = ZippyRadioButton;